import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {ShipmentRoute, ShipmentRouteJSON} from "./shipment-route";
import {User} from "@hassel-it/angular-common";

export class ShipmentDriver {

    id: string;
    external_reference: string;
    scanapp_external_reference: string;
    name: string;
    branch: string;
    last_position: Moment;
    last_x: number;
    last_y: number;
    created: Moment;
    modified: Moment;
    user_id: number;
    shipment_routes: ShipmentRoute[];
    user?: User
   speed?: number
   direction?: number

    static _JSONProps: string[] = [
        'id',
        'user_id',
        'external_reference',
        'scanapp_external_reference',
        'name',
        'branch',
        'last_x',
        'last_y',
        'speed',
        'direction'
    ];

    constructor(initializer?: ShipmentDriverJSON) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: ShipmentDriverJSON | string): ShipmentDriver {
        if (json === null) {
            return new ShipmentDriver();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, ShipmentDriver.reviver);
        } else {
            let shipmentDriver = Object.create(ShipmentDriver.prototype);

            let extra = {
                last_position: json.last_position ? moment(json.last_position) : null,
                created: moment(json.created),
                modified: moment(json.modified),
                shipment_routes: [],
                user: null
            };

            Object.keys(json).forEach((key, index) => {
                if (ShipmentDriver._JSONProps.indexOf(key) !== -1) {
                    shipmentDriver[key] = json[key];
                }

                if (key === 'shipment_routes') {
                    json[key].forEach((value: ShipmentRouteJSON, index) => {
                        extra.shipment_routes.push(ShipmentRoute.fromJSON(value));
                    });
                }

                if (key === 'user') {
                    extra.user = User.fromJSON(json[key]);
                }
            });

            return Object.assign(shipmentDriver, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? ShipmentDriver.fromJSON(value) : value;
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface ShipmentDriverJSON {
    id?: string;
    external_reference?: string;
    name?: string;
    branch?: string;
    last_position?: Moment;
    last_x?: number;
    last_y?: number;
    created?: Moment;
    modified?: Moment;
}
